"use strict";

import angular from "angular";

import { UserDataAdapter } from "../../presentation/adpters/UserDataAdapter";

import _ from "lodash";

export class AccountingFactory {
    constructor() {}

    setId(accountingId) {
        this.accountingId =
            accountingId || new UserDataAdapter().user()?.profile?.accountingId;
    }

    getId() {
        return this.accountingId;
    }

    setDocument(accounting) {
        this.accounting = accounting;
        this.setId(accounting._id);
    }

    getDocument() {
        return this.accounting;
    }

    setAttribute(path, value) {
        _.set(this.accounting, path, value);
    }
}

angular.module("nucont.shared").factory("AccountingFactory", [AccountingFactory]);
